import React from 'react';
import styled from 'styled-components'; 
import constants from 'utils/constants';
import LoadingModal from 'components/presenters/modal/LoadingModal';
import rightArrowIcon from 'images/icon/arrow_right_4e4e4e-25x48.png';
import clearUsernameIcon from 'images/icon/close_btn_grey_circle-18x18.png'
import cameraIcon from 'images/icon/camera_circle_icon_4e4e4e-114x114.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-48x48.png';
import userIcon from 'images/icon/anonymous_user-88x88.png'
export default function SocialShareModal({initData, base64ShareImg, sampleImg, valid, isImgLoading, isImgCancelable, showCopiedMsg, username,
                                        guideTitle, guideMsg, 
                                        onCancelImg, onCopyTag, onChangeUsername, onClickShareBtn, onClickResetUsername, onClickFileSelect}) { 

    const instagramImgSrc = `${constants['imagePath']}/static/icon/instagram_icon_99x99.png`;
    const instagramGreyImgSrc = `${constants['imagePath']}/static/icon/instagram_grey_icon_99x99.png`;
    return (
        <ShareSection>
            {(
                (guideTitle) && (
                <TitleWrapper>
                    <TitleContent>{guideTitle}</TitleContent>
                </TitleWrapper>
            ))}
            {(
                (guideMsg)&& (
                <DescriptionWrapper>
                <DescriptionContent>{guideMsg}</DescriptionContent>
            </DescriptionWrapper>
            ))}
            
            <UsernameSection>
                <UserIconWrapper>
                    <UserIcon src={userIcon} />
                </UserIconWrapper>
                <UsernameInputWrapper>
                    <RedDotWrapper><RedDot></RedDot></RedDotWrapper>
                    <UsernameInput placeholder={'인스타계정 ID 입력'} value={username} onChange={(e)=>{if(onChangeUsername)onChangeUsername(e.target.value)}} />
                    {(username&& (
                    <UsernameClearBtn onClick={(e)=>{if(onClickResetUsername)onClickResetUsername()}}>
                        <UsernameClearBtnIcon src={clearUsernameIcon} />
                    </UsernameClearBtn>
                    ))}
                </UsernameInputWrapper>
            </UsernameSection>
            <ImgWrapper>
                <ImgSection>
                {(base64ShareImg)
                    ?(
                        <>
                            <ImgContent src={base64ShareImg}/>
                            {
                                (isImgCancelable && (
                                    <CancelImgBtn onClick={(e)=>{if(onCancelImg)onCancelImg()}}>
                                        <CancelImgIcon src={cancelIcon}/>
                                    </CancelImgBtn>
                                ))
                            }
                        </>)
                    :(
                        <>{
                            (sampleImg)
                            ?(
                                <ImgContent src={sampleImg}/>)
                            :(null)}
                            <UploadWrapper>
                                <UploadSection onClick={(e)=>{
                                        if(onClickFileSelect)
                                        {
                                            onClickFileSelect()
                                        }
                                }}>
                                    <UploadBackground>
                                    </UploadBackground>
                                    <CameraImgWrapper >
                                        <CameraIconImg  src={cameraIcon}/>
                                    </CameraImgWrapper>
                                </UploadSection>
                            </UploadWrapper>
                        </>
                    )
                }
                {
                    (isImgLoading && (
                        <LoadingModalWrapper>
                            <LoadingModalSection>
                                <LoadingModal zIndex={800}/> 
                            </LoadingModalSection>
                        </LoadingModalWrapper>
                    ))
                }
                </ImgSection>
            </ImgWrapper>

            {(
                initData?.tag && (
                <TagSection>
                    <TagWrapper>
                        <TagContent>{initData?.tag}</TagContent>
                    </TagWrapper>
                    <TagCopyBtn onClick={(e)=>{if(onCopyTag)onCopyTag(initData.tag);}}>
                    <RedDotWrapper><RedDot></RedDot></RedDotWrapper>
                    복사</TagCopyBtn>
                </TagSection>
            ))}
            {
                (valid)
                ?(<InstagramShareValidBtn onClick={(e)=>{if(onClickShareBtn)onClickShareBtn()}}>
                    <InstagramIconWrapper> 
                        <InstagramIcon src={instagramImgSrc}/>
                    </InstagramIconWrapper>
                    인스타에 공유
                    <InstagramArrow src={rightArrowIcon}/>
                </InstagramShareValidBtn>)
                :(<InstagramShareBtn onClick={(e)=>{if(onClickShareBtn)onClickShareBtn()}}>
                    <InstagramIconWrapper> 
                        <InstagramIcon src={instagramGreyImgSrc}/>
                    </InstagramIconWrapper>
                    인스타에 공유
                    <InstagramArrow src={rightArrowIcon}/>
                </InstagramShareBtn>)
            } 
            {
                (<CopiedMsg opacity={(showCopiedMsg)?1:0}>복사 되었습니다!</CopiedMsg>)
            }
            
        </ShareSection>
    )
} //showCopiedMsg
export const TitleWrapper = styled.div` 
    padding : 0 calc(100vw * (22 / 375));
    margin-bottom : calc(100vw * (8 / 375));
`
export const TitleContent = styled.span`
    font-style: normal;
    font-weight: 700;
    font-size: calc(100vw * (20 / 375)); 
    color: #121212;
`
export const DescriptionWrapper = styled.div`
    padding : 0 calc(100vw * (24 / 375));
    margin-bottom : calc(100vw * (19 / 375));
`
export const DescriptionContent = styled.span`
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (14 / 375));
    color: #4E4E4E;
`
export const UsernameSection = styled.div`
    display: flex; 
    padding : 0 calc(100vw * (45 / 375));
    margin-bottom : calc(100vw * (12 / 375));
`
export const UserIconWrapper = styled.div`
    width : calc(100vw * (44 / 375)); 
    height : calc(100vw * (44 / 375)); 
    min-width : calc(100vw * (44 / 375)); 
    min-height : calc(100vw * (44 / 375)); 
    border-radius : 100%;
    overflow: hidden;
    margin-right: 10px;
    flex: 0 1 auto;
`
export const UserIcon = styled.img`
    object-fit: cover;
    height: 100%;
    width : 100%;
`
export const UsernameInputWrapper = styled.div`
    position: relative;
    flex: 1 1 auto;
`
export const UsernameInput = styled.input`
    width : 100%;
    padding: calc(100vw * (11 / 375)) calc(100vw * (35 / 375)) calc(100vw * (11 / 375)) calc(100vw * (20 / 375)); 
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (14 / 375)); 
    color: #121212;

    background: #F7F7F7;
    border-radius: calc(100vw * (6 / 375));

    &::placeholder{
        font-style: normal;
        font-weight: 500;
        font-size: calc(100vw * (14 / 375)); 
        color: #7F7F7F;
    }
`

export const UsernameClearBtn = styled.div` 
    position :absolute;
    right: calc(100vw * (13 / 375));
    top:0;
    bottom : 0;
    margin : auto;
    height: calc(100vw * (18 / 375)); 
    width: calc(100vw * (18 / 375));     
    min-height: calc(100vw * (18 / 375)); 
    min-width: calc(100vw * (18 / 375)); 
`
export const UsernameClearBtnIcon = styled.img` 
    width : 100%;
    height: 100%;
    object-fit: cover;
`
export const ShareSection = styled.div`
    flex: 1 1 auto;
    height: 100%;
    overflow-y: scroll;
`
export const  ImgWrapper = styled.div`
    position :relative;
    padding : 0 calc(100vw * (45 / 375));
    margin-bottom : calc(100vw * (11 / 375));
    border-radius: calc(100vw * (16 / 375));
    overflow : hidden;

`
export const ImgSection = styled.div`
    position: relative;
    width : 100%;
    height: 100%;
`
export const ImgContent = styled.img`
    width: 100%;
    height: 100%;
    object-fit : cover;
    border-radius: calc(100vw * (16 / 375));
`
export const TagSection = styled.div`  
    display: flex;
    flex-direction: row;
    padding : 0 calc(100vw * (45 / 375));
    margin-bottom: calc(100vw * (32 / 375));
`
export const TagWrapper = styled.div` 
    flex: 1 1 auto;

    padding-right : calc(100vw * (12 / 375));
`
export const TagContent = styled.div`

    height: calc(100vw * (60 / 375));
    overflow-y: scroll;
    background: #F7F7F7;
    border-radius: calc(100vw * (5 / 375));
    
    //font
    font-style: normal;
    font-weight: 400;
    font-size: calc(100vw * (14 / 375));
    color: #121212;
    padding : calc(100vw * (7 / 375)) calc(100vw * (11 / 375));
`
export const TagCopyBtn = styled.button`  
    position :relative;
    flex: 0 1 auto;
    font-style: normal;
    font-weight: 700;
    line-height :calc(100vw * (23 / 375));
    font-size: calc(100vw * (16 / 375)); 
    color: #4E4E4E;
    padding : calc(100vw * (10 / 375)) calc(100vw * (19 / 375)); 
    background: #FFCF19;
    border-radius: calc(100vw * (5 / 375));
    height: fit-content;
    min-width : fit-content;
`

export const InstagramShareBtn = styled.div`
    margin : 0 auto;
    width: fit-content;
    align-items: center;
    justify-content: center;
    display : flex;
    text-align: center;
    padding : calc(100vw * (15 / 375)) calc(100vw * (24 / 375)) calc(100vw * (15 / 375)) calc(100vw * (27 / 375)); 
    background: #EAEAEA;
    border-radius: calc(100vw * (32 / 375));

    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (16 / 375));  
    text-align: center; 
    color: #4E4E4E;
`
export const InstagramShareValidBtn = styled(InstagramShareBtn)`
    background: #ffffff;
    color: #121212;
    box-shadow: 0px 0px 30px #F3F3F3;
`
export const InstagramIconWrapper = styled.div`
    display: inline-block;
    width: calc(100vw * (33 / 375));
    height: calc(100vw * (33 / 375));
    min-width: calc(100vw * (33 / 375));
    min-height: calc(100vw * (33 / 375));
    margin-right: calc(100vw * (8 / 375));
`
export const InstagramIcon = styled.img``
export const InstagramArrow =styled.img`
    margin-left: calc(100vw * (19 / 375));
    width: calc(100vw * (8 / 375));
    height: calc(100vw * (14 / 375));
`

export const CopiedMsg = styled.div`
    position: absolute;
    top:0;
    bottom : 0;
    left:0;
    right: 0;
    width : fit-content;
    height: calc(100vw * (54 / 375));
    margin : auto;
    z-index:100;
    transition : all 0.5s ease;
    opacity :${(props) => props.opacity};
    //font
    font-style: normal;
    font-weight: 500;
    font-size: calc(100vw * (16 / 375));
    line-height: 23px; 
    color: #121212;

    background: #F7F7F7;
    border-radius: 5px;
    padding : calc(100vw * (15 / 375)) calc(100vw * (26 / 375));
`

export const UploadWrapper = styled.div`
    position :absolute;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    margin : auto;
    padding: inherit
`

export const UploadSection = styled.div`
    cursor: pointer;
    position: relative;
    width : 100%;
    height: 100%;
`
export const UploadBackground = styled.div`
    border-radius: 16px;
    background: #FFFFFF;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
`

export const CameraImgWrapper = styled.div` 
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    margin : auto;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

`
export const CameraIconImg = styled.img`
    display: inline-block;
    width : calc(100vw * (57 / 375));
    height : calc(100vw * (57 / 375));

`
export const LoadingModalWrapper = styled.div`
    position :absolute;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    margin : auto;
    padding: inherit
`
export const LoadingModalSection = styled.div` 
    position: relative;
    width : 100%;
    height: 100%;
`

export const CancelImgBtn = styled.button`
    position :absolute;
    top : calc(100vw * (13 / 375));
    right: calc(100vw * (13 / 375));
    display: inline-block;
    width : calc(100vw * (24 / 375));
    height : calc(100vw * (24 / 375));
`
export const CancelImgIcon = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`
export const RedDotWrapper = styled.div`
    position :absolute;
    top: -1px;
    left: -2px;
`
export const RedDot = styled.div`
    display: inline-block;
    height: calc(100vw * (8 / 375));
    width: calc(100vw * (8 / 375));
    background : #DA0A16;
    border-radius: 100%;
`